import { useEffect } from "react";

const useScrollerClass = () => {
  useEffect(() => {
    const updateClass = () => {
      const { innerWidth: w, innerHeight: h } = window;

      // If height is less than or equal to 2:1 ratio, scrollbar likely needed
      const needsScrollbar = h <= w / 2;

      document.body.classList.toggle("has-scroller", needsScrollbar);
    };

    updateClass();
    window.addEventListener("resize", updateClass);
    return () => window.removeEventListener("resize", updateClass);
  }, []);
};

export default useScrollerClass;
